import React, { useState, useEffect } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import Navigation from '../components/Navigation'
import Navbar from '../components/Navigation/Navbar'
import { session } from '../utils/AuthSession'
import { ThemeProvider } from '../context/ThemeContext'

function MainLayout() {
    const [authSession] = useState(session())

    if(authSession){
        return (
            <ThemeProvider>
                <div className='relative h-screen'>
                    <Navbar />
                    <div className='pt-16 pb-16 h-full overflow-auto scrollbar-hide'>
                        <Outlet />
                    </div>
                    <Navigation />
                </div>
            </ThemeProvider>
        )
    }else{
        return (
            <Navigate to="/auth/login" replace={true} />
        )
    }
    
}

export default MainLayout